/**
 * For each video player, create custom thumbnail or
 * use YouTube max resolution default thumbnail and create
 * iframe video.
 *
 * Modified from:
 * https://dev.to/wlarch/custom-youtube-thumbnail-and-play-button-for-embedded-iframe-video-25pb
 */

export default {
    init() {
        if (document.querySelector('.youtube-player')) {
            document.querySelectorAll('.youtube-player')
                .forEach(player => {
                    let p = document.createElement("div");
                    let id = player.getAttribute("data-id");

                    let placeholder = player.hasAttribute("data-thumbnail")
                        ? player.getAttribute("data-thumbnail")
                        : "";

                    if (placeholder.length) p.innerHTML = this.createCustomThumbail(placeholder);
                    else p.innerHTML = this.createThumbail(id);

                    player.appendChild(p);
                    p.addEventListener("click", (e) => {
                        let parent = e.currentTarget.parentNode;
                        this.createIframe(parent, parent.getAttribute("data-id"));
                    });
                });
        }
    },
    /**
     * Create custom thumbnail from data-attribute provided url
     * @param {string} url
     * @return {string} The HTML containing the <img> tag
     */
    createCustomThumbail(url) {
        return (
            '<img class="youtube-thumbnail" src="' +
            url +
            '" alt="Youtube Preview" /><div class="youtube-play-btn"></div>'
        );
    },
    /**
     * Get YouTube default max resolution thumbnail
     * @param {string} id The YouTube video id
     * @return {string} The HTML containing the <img> tag
     */
    createThumbail(id) {
        return (
            `<img class="youtube-thumbnail" src="https://img.youtube.com/vi/${id}/0.jpg" alt="Youtube Preview"><div class="youtube-play-btn"></div>`
        );
    },
    /**
     * Create and load iframe in YouTube container
     **/
    createIframe(v, id) {
        let iframe = document.createElement("iframe");
        //console.log(v);
        iframe.setAttribute(
            "src",
            "//www.youtube.com/embed/" +
            id +
            "?autoplay=1&color=white&autohide=2&modestbranding=1&border=0&wmode=opaque&enablejsapi=1&showinfo=0&rel=0"
        );
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("class", "youtube-iframe");
        v.firstChild.replaceWith(iframe);
    }
}
